import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { map } from 'rxjs/internal/operators/map';
import { Observable } from 'rxjs';
import { Response } from 'src/app/shared/models/response.model';
const routes = {
  branch: (id: number) => `/enterprises/${id}`,
  updateBranch:  (id: number) => `/enterprises/update/${id}`,
  allBranchesAndParentEnterprises: (currentEnterpriseId: string) => `/enterprises/group/${currentEnterpriseId}`
};

@Injectable({
  providedIn: 'root'
})
export class MenuExportReportService {
  constructor(
    private apiService: ApiService,
  ) { }

  getDataConfigHDLD(){
    return this.apiService.get('/enterprises/moha/config').pipe(map(res => {
      return res;
    }));
  }

  getListReport(body: any = {}):Observable<Response<any>> {
    return this.apiService.post('/report/filter', body)
      .pipe(map(res => {
        return res;
      }));
  }

  // getListReportForCreate(body: any = {}):Observable<Response<any>> {
  //   return this.apiService.post('/contract-employment/report/filter', body)
  //     .pipe(map(res => {
  //       return res;
  //     }));
  // }
  getListReportForCreate(params: any) {
    return this.apiService.get('/moha-report/labor-contracts-for-report', params).pipe(
      map((res: any) => res)
    );
  }
  createReport(body: any) {
    return this.apiService.post('/report/create', body)
  }

  sendReport(body: any, id: string | null) {
    if(id){
      return this.apiService.post('/report/send-report/' + id, body)
    } else {
      return this.apiService.post('/report/send-report', body)
    }
  }

  getReportById(id: any) {
    return this.apiService.get(`/report/detail/${id}`)
  }

  updateReport(body: any) {
    return this.apiService.post('/report/update', body)
  }

  deleteReport(id: any) {
    return this.apiService.delete(`/moha-report/delete/${id}`);
  }
  createReportMoha(body: any): Observable<any> {
    return this.apiService.post('/moha-report/create', body).pipe(
      map((res: any) => res)
    );
  }
  getReportDetail(encryptedId: string, isForCopy: boolean = false): Observable<any> {
    const url = `/moha-report/detail?id=${encryptedId}&isForCopy=${isForCopy}`;
    return this.apiService.get(url).pipe(
      map((res: any) => res)
    );
  }
  downloadReportFile(id: string): Observable<any> {
    return this.apiService.getFileWithResponse(`/moha-report/download/${id}`);
  }
  getViewPdfByPath(pdfFilePath: string): Observable<Blob> {
    return this.apiService.getFilePostMethod(
      '/file/view/moha-report-by-path',
      { pdfFilePath }
    ).pipe(
      map((res: Blob) => res)
    );
  }
  
}
